import React from 'react';
import propTypes from 'prop-types';
import { Button, CloseWrapper, Stepper, TextInput } from '@tcc/crate';
import { getMessage } from 'util/locale';

const EditLegend = ({ 
  decrementSteps, 
  incrementSteps, 
  isFormInvalid, 
  legend, 
  onCancel,
  onSave,
  setMax, 
  setMin
}) => {

  if (!legend.steps) {
    return null;
  }
  const baseString = 'vra-edit-legend';

  return (
    <CloseWrapper onRootClose={onCancel} onClickAway={onCancel}>
      <div className={`${baseString}__editPanel`}>
        <div className={`${baseString}__inputContainer`}>
          <div className={`${baseString}__editHeader`}>
            {getMessage('title-text__edit-legend')}
          </div>
          <div className={`${baseString}__stepsContainer`}>
            {getMessage('label-text__steps')}
            <Stepper
              displayItem={legend.steps}
              onDecrement={decrementSteps}
              onIncrement={incrementSteps}
            />
          </div>
          <div className={`${baseString}__maxMinContainer`}>
            <span className={`${baseString}__maxMinLabel`}>{getMessage('label-text__max')}</span>
            <TextInput
              className={`${baseString}__maxMinInput`}
              error={isFormInvalid}
              name='max-value-input'
              onChange={setMax}
              placeholder={legend.maxValue}
              showLabel={false}
              showReset={false}
              type='Number'
              value={legend.maxValue} />
          </div>
          <div className={`${baseString}__maxMinContainer`}>
            <span className={`${baseString}__maxMinLabel`}>{getMessage('label-text__min')}</span>
            <TextInput
              className={`${baseString}__maxMinInput`}
              error={isFormInvalid}
              name='min-value-input'
              onChange={setMin}
              placeholder={legend.minValue}
              showLabel={false}
              showReset={false}
              type='Number'
              value={legend.minValue} />
          </div>
        </div>
        <div className={`${baseString}__buttonContainer`}>
          <Button
            className={`${baseString}__cancelButton`}
            mode="secondary"
            onClick={onCancel}>{getMessage('button-text__cancel')}
          </Button>
          <Button
            className={`${baseString}__saveButton`}
            disabled={isFormInvalid}
            mode="primary"
            onClick={onSave}>{getMessage('button-text__save')}
          </Button>
        </div>
      </div>
    </CloseWrapper>
  );
};

EditLegend.propTypes = {
  decrementSteps: propTypes.func, 
  incrementSteps: propTypes.func, 
  isFormInvalid: propTypes.bool, 
  legend: propTypes.object, 
  onCancel: propTypes.func,
  onSave: propTypes.func, 
  setMax: propTypes.func, 
  setMin: propTypes.func 
};


export default EditLegend;
